<label class="switch">
  <input type="checkbox" [(ngModel)]="value" />
  <span class="slider"></span>
</label>
